import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { otherDeductionsDetailInputList5 } from '../../../../common/data';

import InputItemSection from '../OtherInputItemSection';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import { getOtherDeductionsData5 } from '../otherDeductionsSlice';
import Typography from '../../../../components/common/Typography';
import Radio from '../../../../components/common/Radio';
import TextField from '../../../../components/common/TextField';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';

// 세액공제
const Type5 = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const { t: tCommon } = useTranslation('common');
  const inputList = otherDeductionsDetailInputList5(t);
  const { s11_5Data, detailReload } = useSelector(state => state.otherDeductions);
  const [dataList, setDataList] = useState({});

  useEffect(() => {
    //초기는 메인에서 받는다. 삭제, 저장할때만 다시받음
    if (detailReload != -1) {
      dispatch(getOtherDeductionsData5());
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      setDataList({
        ...s11_5Data,
        htm062: s11_5Data.htm062 == '1' ? '1' : '',
        htmTaxFlag: s11_5Data.htmTaxFlag == '1' ? '1' : '',
      });
    }
  }, [s11_5Data]);

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={`${t('detail.type5.title')}`} />
        <InputItemSection
          dataList={dataList}
          inputList={inputList}
          setDataList={setDataList}
          addButton={true}
          disabled={true}
          htmFlag="5"
        />
        <Typography variant="body2Medium">{t('detail.type5.radioLabel1')}</Typography>
        <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
          <Radio
            label={tCommon('radioGroup.yes')}
            size="medium"
            checked={dataList.htm062 == '1'}
            value="1"
            onChange={() => {}}
          />
          <Radio
            label={tCommon('radioGroup.no')}
            size="medium"
            checked={dataList.htm062 != '1'}
            value=""
            onChange={() => {}}
          />
        </div>
        <Typography variant="body2Medium">{t('detail.type5.radioLabel2')}</Typography>
        <div className="displayFlex" style={{ gap: '40px', justifyContent: 'flex-end' }}>
          <Radio
            label={tCommon('radioGroup.yes')}
            size="medium"
            checked={dataList.htmTaxFlag == '1'}
            value="1"
            onChange={() => {}}
          />
          <Radio
            label={tCommon('radioGroup.no')}
            size="medium"
            checked={dataList.htmTaxFlag != '1'}
            value=""
            onChange={() => {}}
          />
        </div>
        <TextField
          size="small"
          label={t('detail.type5.inputLabel4')}
          value={dataList.htm143}
          disabled={true}
        />
      </div>
    </SlideRightDialog>
  );
};

export default Type5;
